/** Department display name from employee / plan tour (matches CRM title). */
export const QUALITY_INDORE_DEPARTMENT = 'Quality - Indore';

/**
 * Bakery Noida display name on SharePoint EmployeeList — often stored on **Plant** (`PlantId/Title`),
 * not on Department, while HomePage may also match it on `departmentName`.
 */
export const BAKERY_NOIDA_DEPARTMENT = 'Bakery - Noida';

const BAKERY_NOIDA_NORMALIZED = 'bakery - noida';

/** Collapse spaces and normalize en/em dash to hyphen for label comparison. */
function normalizeLocationLabel(s: string | null | undefined): string {
  if (!s) return '';
  return s
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

type EmployeeLike = {
  departmentName?: string;
  plantName?: string;
  DepartmentName?: string;
  PlantName?: string;
} | null | undefined;

/**
 * True if department **or** plant (SharePoint) is Bakery - Noida. Many Noida users have
 * a Quality* department and `plantName` "Bakery - Noida".
 */
function looksLikeBakeryNoida(s: string): boolean {
  if (!s) return false;
  return s.includes('noida') && s.includes('bakery');
}

/** True if SharePoint / CRM label matches "Bakery - Noida" or clearly refers to that bakery (noida + bakery). */
export function isBakeryNoidaEmployee(employee: EmployeeLike): boolean {
  if (!employee) return false;
  const d = normalizeLocationLabel(employee.departmentName ?? employee.DepartmentName);
  const p = normalizeLocationLabel(employee.plantName ?? employee.PlantName);
  if (d === BAKERY_NOIDA_NORMALIZED || p === BAKERY_NOIDA_NORMALIZED) return true;
  return looksLikeBakeryNoida(d) || looksLikeBakeryNoida(p);
}
